import { render, staticRenderFns } from "./ManagePools.vue?vue&type=template&id=07c9a64a&lang=html"
import script from "./ManagePools.vue?vue&type=script&lang=js"
export * from "./ManagePools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports